import { leerPosicionDispositivo } from './geoPosicion';
import { resolverPosicion } from './posicion';
import type { PosicionContext } from './types';

export * from './types';
export { buildUiContextSnapshot, UI_CONTEXT_MAX_CARAVANAS } from './snapshot';
export { resolverPosicion, GPS_MAX_ACCURACY_M, GPS_MAX_AGE_MS, GPS_LIMITE_M, type LecturaGps } from './posicion';

const withTimeout = <T,>(p: Promise<T>, ms: number, fallback: T) =>
  Promise.race([p, new Promise<T>((r) => setTimeout(() => r(fallback), ms))]);

/** Cuadro/corral donde está el usuario, o null. Nunca tira ni demora el envío más de 2 s. */
export async function getPosicionContext(empresaId: string | null): Promise<PosicionContext | null> {
  if (!empresaId) return null;
  return withTimeout((async () => {
    try {
      const lectura = await leerPosicionDispositivo();
      if (!lectura) return null;
      // Import diferido: el factory arrastra todos los repositorios; así el ChatContext
      // (web y mobile) no los carga al importarse — sólo cuando hay una lectura de GPS.
      const { getDatabaseFactory } = await import('../../storage/DatabaseFactory');
      const repo = getDatabaseFactory().elementoMapaRepository;
      const [cuadros, corrales] = await Promise.all([repo.getByTipo(empresaId, 'CUADRO'), repo.getByTipo(empresaId, 'CORRAL')]);
      return resolverPosicion(lectura, [...corrales, ...cuadros]);
    } catch {
      return null;
    }
  })(), 2_000, null);
}
